import {
  SET_NOTIFICATIONS,
  RESET_NOTIFICATION,
  LOADING_NOTIFICATION,
  STOP_LOADING_NOTIFICATION,
  DELETE_NOTIFICATION,
} from '../types'

const initialState = {
  loading: false,
  notifications: [],
}

const notificationReducer = (state = initialState, action) => {
  let index
  switch (action.type) {
    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
        loading: false,
      }

    case LOADING_NOTIFICATION:
      return {
        ...state,
        loading: true,
      }
    case STOP_LOADING_NOTIFICATION:
      return {
        ...state,
        loading: false,
      }

    case DELETE_NOTIFICATION:
      index = state.notifications.findIndex((notification) => notification.id === action.payload)
      if (index !== -1) {
        state.notifications.splice(index, 1)
      }
      return { ...state }

    case RESET_NOTIFICATION:
      return initialState

    default:
      return state
  }
}

export default notificationReducer
